<template>
    <div v-if="field">
        <b-input-group>
            <img :src="localURL" width="250px" v-if="store.getters.isRunModePlatform && content != ''"/>
            <img :src="preview" width="250px" v-else/>

            <b-form-invalid-feedback :id="field.key" style="display:block">
            {{ errors[0] || null }}
            </b-form-invalid-feedback>
         </b-input-group>

         <b-input-group v-if="!this.field.protected">
            <b-dropdown id="ddown1" text="Source" class="m-2">
                <b-dropdown-item @click="chooseFrom('library')" v-if="showChooseFromLibrary">Choose from library</b-dropdown-item>
                <b-dropdown-item @click="chooseFrom('device')" v-if="customData.chooseFromDevice">Choose from device</b-dropdown-item>
                <b-dropdown-item @click="chooseFrom('external')" v-if="customData.chooseExternalSource">External source</b-dropdown-item>
            </b-dropdown>
         </b-input-group>

      <main-dialog v-model="chooseModal.show" hide-footer hide-header size="lg">
          <Library @itemsSelected="itemSelected" v-if="this.chooseModal.type == 'library'"  :filterLibraries="constraints.custom_data.libraries" :filterExtensions="['jpg', 'jpeg', 'png', 'gif', 'webp']" />
          <b-form-input placeholder="https://example.imagepng.com/nice_background.png" v-model="content" v-if="this.chooseModal.type == 'external'" />
          <div v-if="this.chooseModal.type == 'device'">
            <b-form-file v-model="uploadFile" accept="image/*" @change="previewImage" />
            <b-button @click="upload" v-if="uploadFile" class="m-2"> Upload </b-button>
          </div>
      </main-dialog>
    </div>
</template>

<script>
export default {
    name: "IdentityField_Image",
    components: {
        Library: () => import('@/components/integrations/protokol/media/Index')
    },
    props: {
        field: {
            type: Object
        },
        value: {
            type: String | Number,
            default: ""
        },
        store: {
            type: Object
        },
        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: [],
            uploadModal: {
                show: false,
                file: null
            },
            chooseModal: {
                show: false,
                file: null,
                type: ''
            },
            image: null,
            imageLoadingError: false,
            uploadFile: null,
            preview: null
        }
    },
    computed: {
        content: {
            get() {
                if (this.value == "") {
                    return this.constraints.default || ""
                }

                return this.value;
            },

            set(val) {
                this.check(val)
                this.$emit('input', val);
            }
        },
        constraints() {
            let constr = this.field.constraints
            let {custom_data} = constr
            
            if (!custom_data) {
                constr.custom_data = {
                    image: {
                        chooseFromLibrary: true,
                        chooseFromDevice: true,
                        chooseExternalSource: true,
                        libraries: [],
                        defaultLibrary: null
                    }
                }
            }

            return constr
        },

        customData() {
            return this.constraints.custom_data.image
        },

        localURL() {
            return this.$mediaHttp.defaults.baseURL + this.content
        },

        showChooseFromLibrary() {
            return this.store.getters.isRunModePlatform && (this.customData.chooseFromLibrary && this.store.getters.isIntegrationActive('protokol-media'))
        }
    },
    watch: {
        content(val) {
            this.check(val)
        }
    },
    methods: {
        check(val) {
            this.errors = []

            if (val == "" && this.constraints.required) {
                this.errors.push(this.translator("identityField.requiredField"))
            }
                
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
        },

        itemSelected(d) {
            let item = null
            if (d.length > 0) {
                item = d[0]
            }

            this.content = "/media/library/" + item.library_uuid + "/get/" + item.key
        },


        chooseFrom(source) {
            this.chooseModal.show = true
            this.chooseModal.type = source
        },

        upload() {
            this.store.dispatch("uploadMedia", {uploadDir: "", uuid: this.customData.defaultLibrary, files: [this.uploadFile], field: this.field.key}).then(resp => {
                let d = resp.data[0]

                this.chooseModal.show = false
                this.content = "/media/library/" + d.library_uuid + "/get/" + d.key
            }).catch(err => {
                this.$mainDialog.msgBoxOk(err.response.data.message)
            })
        },

        previewImage(e) {
            const file = e.target.files[0];
            this.preview = URL.createObjectURL(file);
        }

    },

    mounted() {
        this.check(this.content)
    }

    }
</script>